export default __webpack_public_path__ + "static/media/3.47f45c7b.png";